import { AspectRatio, Text, Image } from '@mantine/core'
import { Match } from '../../../matches/api'
import dayjs from 'dayjs'
import classes from './MatchHeader.module.css'
import { useMediaQuery } from '@mantine/hooks'
import clsx from 'clsx'
import { HeaderBar } from './Header'

export default function MatchHeader({ match }: { match: Match }) {
  const isDesktop = useMediaQuery('(min-width: 800px)')
  return (
    <div
      className={clsx(classes.match_header_container, {
        [classes.header_desktop]: isDesktop,
      })}
    >
      {!isDesktop && <HeaderBar back={-1} />}
      <div
        className={clsx(classes.grid, { [classes.grid_mobile]: !isDesktop })}
      >
        {!isDesktop && (
          <Text component="h1" className={classes.title}>
            Match Stats
          </Text>
        )}
        <div
          className={clsx(classes.team_container, {
            [classes.home_team_container]: !isDesktop,
          })}
        >
          <Text component="h5" className={classes.team_name}>
            {match.home_team_name}
          </Text>
          <AspectRatio ratio={1 / 1}>
            <Image
              src={match.home_team_logo.thumbnail}
              alt={match.home_team_name}
              className={classes.team_logo}
              fit="scale-down"
              data-mobile={!isDesktop}
            />
          </AspectRatio>
        </div>
        <div className={classes.match_details_container}>
          <Text component="p" className={classes.match_details_description}>
            {`Round ${match.round_number}`}
            <br />
            {`${dayjs(match.round_start).format('D MMM')} - ${dayjs(match.round_start).add(6, 'day').format('D MMM')}`}
          </Text>
          {match.round_status === 'upcoming' ? (
            <Text component="p" className={classes.round_status}>
              {match.round_status}
            </Text>
          ) : (
            <div className={classes.score_container}>
              <Text component="h2" className={classes.score}>
                {match.home_team_score} - {match.away_team_score}
              </Text>
              <Text component="p" className={classes.round_status}>
                {match.round_status === 'live' ? 'Now playing' : 'Full-time'}
              </Text>
            </div>
          )}
        </div>
        <div
          className={clsx(classes.team_container, {
            [classes.away_team_container]: !isDesktop,
          })}
        >
          <AspectRatio ratio={1 / 1}>
            <Image
              src={match.away_team_logo.thumbnail}
              alt={match.away_team_name}
              className={classes.team_logo}
              fit="scale-down"
              data-mobile={!isDesktop}
            />
          </AspectRatio>
          <Text component="h5" className={classes.team_name}>
            {match.away_team_id == null ? 'BYE' : match.away_team_name}
          </Text>
        </div>
      </div>
    </div>
  )
}
